module.exports = __webpack_public_path__ + "img/banner-Sp.8eead915.png";